import React, { useEffect, useState } from 'react';
import './ImageComponent.scss'
import playOutlineFilled from '../../assets/images/CommonComponent/playOutlineFilled.png';
import { getDataFromFirebase } from '../../Config/commonFirebaseImage';
import { Skeleton } from '@mui/material';

const ImageComponent = ({width, height, path, url="", showPlayButton=false, mediaType}) => {
    const [firebaseURL, setFirebaseURL] = useState(url)
    const [loading, setLoading] = useState(true)

    const getURL= async()=>{
        setLoading(true)
        let url_ = await getDataFromFirebase(path)
        setFirebaseURL(url_)
        setLoading(false)
    }

    useEffect(()=>{
        if(path && !url){
            getURL()
        }else{
            setLoading(false)
        }
    }, [path])

  return (
    <div className='imageComponent'>
        {
           loading ? <Skeleton variant="rounded" className='my-2' width={width || "85px"} height={height || "85px"} />
            :
            <>
            {
                firebaseURL ?
                <div className='imgDivContent' style={{ width: width || "85px", height: height || "85px"}}>
                    {firebaseURL && <img className="mainIcon" src={firebaseURL} alt=""  />}
                    {showPlayButton && <img className="videoPlayIcon" src={playOutlineFilled} alt="" width="60px" height="60px" />}
                </div>
                :
                <div className='notUploaded'>
                    {mediaType} not uploaded
                </div>
            }
            </>

        }
    </div>
  )
}

export default ImageComponent;